"use strict";
/* MCJ smart recently-viewed upsell. Renders a "You may also like" grid
   using Shopify's native related/complementary recommendations, falling
   back to catalog products when there is no view history. */
(function () {
  function onReady(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  onReady(init);

  function init(){
    var SEC = document.querySelector('.bls__rvp-page-section');
    if(!SEC) return;
    var wrap = document.querySelector('[data-mcj-upsell]');
    if(!wrap) return;
    var grid = wrap.querySelector('.mcj-upsell-grid');
    if(!grid) return;
    var titleEl = wrap.querySelector('.mcj-upsell-title');
    var subEl = wrap.querySelector('.mcj-upsell-sub');
    var searchUrl = (window.routes && window.routes.search_url) || '/search';

    function viewed(){ try{ return JSON.parse(localStorage.getItem('bls__recently-viewed-products'))||[]; }catch(e){ return []; } }

    function pushId(arr, seen, excl, id){
      id = String(id);
      if(!id || id==='undefined' || seen.has(id) || excl.has(id)) return;
      seen.add(id); arr.push(id);
    }

    async function recoIds(){
      var v = viewed();
      var excl = new Set(v.map(function(x){ return String(x.id); }));
      var seen = new Set(), ids = [];
      var seeds = v.slice(0,4);
      for(var i=0;i<seeds.length;i++){
        var sid = seeds[i] && seeds[i].id;
        if(!sid) continue;
        var intents = (i===0) ? ['complementary','related'] : ['related'];
        for(var k=0;k<intents.length;k++){
          try{
            var r = await fetch('/recommendations/products.json?product_id='+sid+'&intent='+intents[k]+'&limit=10');
            if(!r.ok) continue;
            var j = await r.json();
            (j.products||[]).forEach(function(p){ pushId(ids, seen, excl, p.id); });
          }catch(e){}
          if(ids.length>=14) break;
        }
        if(ids.length>=14) break;
      }
      return ids.slice(0,12);
    }

    async function fallbackIds(){
      try{
        var r = await fetch('/products.json?limit=24');
        var j = await r.json();
        var arr = (j.products||[]).map(function(p){ return String(p.id); });
        for(var i=arr.length-1;i>0;i--){ var t=(Date.now()+i)%(i+1); var tmp=arr[i]; arr[i]=arr[t]; arr[t]=tmp; }
        return arr.slice(0,12);
      }catch(e){ return []; }
    }

    async function renderInto(ids){
      if(!ids || !ids.length) return false;
      var q=''; ids.forEach(function(id,i){ q += (i? '%20OR%20id:':'') + id; });
      var url = searchUrl + '?view=rv-products&type=product&options[unavailable_products]=last&q=id:' + q;
      var res = await fetch(url);
      var txt = await res.text();
      var doc = new DOMParser().parseFromString(txt,'text/html');
      var row = doc.querySelector('.bls__rv-page-main > .row');
      if(!row || !row.children.length) return false;
      grid.innerHTML = row.innerHTML;
      try{ if(window.BlsColorSwatchesShopify) BlsColorSwatchesShopify.init(); }catch(e){}
      try{ if(window.BlsSubActionProduct){ BlsSubActionProduct.handleInitQuickviewAction(); BlsSubActionProduct.init(); } }catch(e){}
      try{ if(window.BlsLazyloadImg) BlsLazyloadImg.init(); }catch(e){}
      try{ document.dispatchEvent(new CustomEvent('mcj:cards-added')); }catch(e){}
      return true;
    }

    (async function(){
      var v = viewed();
      var ids = [];
      if(v.length){ ids = await recoIds(); }
      if(!ids.length){
        ids = await fallbackIds();
        if(titleEl) titleEl.textContent = 'Popular right now';
        if(subEl) subEl.textContent = 'Bestsellers our customers love';
      }
      var ok = await renderInto(ids);
      if(ok){ wrap.classList.remove('d-none'); }
    })();
  }
})();
